/**
 * Bitget timeframe configuration and interval mapping.
 * @see https://www.bitget.com/api-doc/spot/market/Get-Candles
 */

import {
  registerExchangeTimeframes,
  resolutionToSeconds,
  type TimeframeConfig,
} from '../../lib/timeframes';

/**
 * Bitget supported kline intervals.
 */
export const BITGET_TIMEFRAMES: TimeframeConfig = {
  native: [
    '1min',
    '3min',
    '5min',
    '15min',
    '30min',
    '1h',
    '4h',
    '6h',
    '12h',
    '1day',
    '1week',
    '1M',
  ],
  synthetic: ['1s'], // Use ticker for 1s
  minIntervalSeconds: 60,
};

// Register with central registry
registerExchangeTimeframes('bitget', BITGET_TIMEFRAMES);

/**
 * Maps TradingView resolution to Bitget interval format.
 */
export const mapToBitgetInterval = (resolution: string): string => {
  const seconds = resolutionToSeconds(resolution);

  if (seconds < 60) return '1min';
  if (seconds === 60) return '1min';
  if (seconds === 180) return '3min';
  if (seconds === 300) return '5min';
  if (seconds === 900) return '15min';
  if (seconds === 1800) return '30min';
  if (seconds === 3600) return '1h';
  if (seconds === 14400) return '4h';
  if (seconds === 21600) return '6h';
  if (seconds === 43200) return '12h';
  if (seconds === 86400) return '1day';
  if (seconds === 604800) return '1week';
  if (seconds === 2592000) return '1M';

  // Default to closest
  if (seconds < 180) return '1min';
  if (seconds < 300) return '3min';
  if (seconds < 900) return '5min';
  if (seconds < 1800) return '15min';
  if (seconds < 3600) return '30min';
  if (seconds < 14400) return '1h';
  if (seconds < 21600) return '4h';
  if (seconds < 43200) return '6h';
  if (seconds < 86400) return '12h';
  if (seconds < 604800) return '1day';
  if (seconds < 2592000) return '1week';

  return '1M';
};
